<template>
    <div id="produk">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Pembayaran',
                    to: { path: '/produk' },
                    exact: true,
                },
                { text: 'Jadwal Kelas' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Jadwal Kelas</h3>

        <v-card>
            <v-card-title>
                Daftar Jadwal Kelas
                <v-spacer></v-spacer>
                <v-btn
                    class="align-center text-body-2 blew white--text"
                    text
                    @click="createProduk()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Jadwal Kelas
                </v-btn>
            </v-card-title>

            <v-divider />

            <app-datatable
                :items="produkList"
                :headers="headers"
                :hasAction="true"
                :has-custom-pagination="false"
                :custom-pagination-total-items="produkList.length"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                :loading="isLoading"
                v-on:dblClicked="updateProduk()"
                v-on:deleted="deleteProduk($event)"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: headersKey[$event.key] }
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "jadwalkelas",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            produkList: [],
            status: {
                PUBLISH: "PUBLISHED",
                UNPUBLISH: "UNPUBLISHED",
            },
            selectedRow: null,
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: [
                { text: "ID", value: "id" },
                { text: "Deskripsi", value: "description" },
                { text: "Partisipan", value: "members" },
                { text: "Kuota", value: "quota" },
                { text: "Threshold", value: "threshold" },
                { text: "Mulai", value: "start_time" },
                { text: "Berakhir", value: "end_time" },
            ],
            headersKey: [
                "id",
                "description",
                "members",
                "quota",
                "threshold",
                "start_time",
                "end_time",
            ],
        };
    },

    mounted: function () {
        this.fetchData();
    },

    watch: {
        pagination: function () {
            this.fetchData();
        },
    },

    methods: {
        fetchData: function () {
            var context = this;

            this.isLoading = true;
            SalesService.getListJadwalKelas(function (result) {
                context.produkList = [];

                if (result.success) {
                    result.data.forEach(function (content, index) {
                        var row = {
                            no: index,
                            id: content.id,
                            description: content.description,
                            members: content.members_number,
                            quota: content.quota,
                            threshold: content.threshold,
                            start_time: content.start_time,
                            end_time: content.end_time,
                        };

                        context.produkList.push(row);
                    });
                    context.isLoading = false;
                } else {
                    alert("Terjadi kesalahan : " + result.message);
                    context.isLoading = false;
                }
            });
        },

        createProduk: function () {
            this.$router.push({ path: "/jadwal-kelas/form" });
        },

        updateProduk: function () {
            var produkId = this.selectedRow.id;
            this.$router.push({
                path: "/jadwal-kelas/form",
                query: { id: produkId },
            });
        },

        updateAllProdukStatus: function (status) {
            var context = this;
            var confirmed = window.confirm(
                "Apakah anda yakin akan mengupdate semua status produk?",
            );

            if (confirmed) {
                this.isLoading = true;
                SalesService.updateAllProdukStatus(status, function (result) {
                    context.isLoading = false;

                    if (result.success) {
                        alert("Data Terupdate");
                        context.fetchData();
                    } else {
                        alert("Terjadi Kesalahan : " + result.message);
                    }
                });
            }
        },

        deleteProduk: function (produk) {
            var context = this;
            var produkId = produk.id;
            var confirmed = window.confirm(
                "Apakah anda yakin akan menghapus jadwal ini?",
            );

            if (confirmed) {
                this.isLoading = true;
                SalesService.hapusPaket(produkId, function (result) {
                    context.isLoading = false;
                    if (result.success) {
                        alert("Data Terhapus");
                        context.fetchData();
                    } else {
                        alert("Terjadi Kesalahan : " + result.message);
                    }
                });
            }
        },

        convertToRupiah: function (value) {
            var rupiah = "";
            var angkarev = value.toString().split("").reverse().join("");

            for (var i = 0; i < angkarev.length; i++)
                if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
            return (
                "Rp " +
                rupiah
                    .split("", rupiah.length - 1)
                    .reverse()
                    .join("")
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// JadwalKelas.vue?170f7287